const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: "base" });

/**
 * @param {string} a
 * @param {string} b
 * @param {boolean} numeric
 */
function compareValues(a, b, numeric) {
  if (numeric) {
    const aNumber = Number(a);
    const bNumber = Number(b);
    if (Number.isFinite(aNumber) && Number.isFinite(bNumber)) return aNumber - bNumber;
  }

  return collator.compare(a, b);
}

document.addEventListener("click", event => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const button = target.closest("[data-reference-sort-column]");
  if (!(button instanceof HTMLButtonElement)) return;

  const table = button.closest("[data-reference-sort-table]");
  const header = button.closest("th");
  const columnIndex = Number(button.dataset.referenceSortColumn);
  if (
    !(table instanceof HTMLTableElement) ||
    !(header instanceof HTMLTableCellElement) ||
    !Number.isInteger(columnIndex)
  )
    return;
  const body = table.tBodies[0];
  if (!body) return;

  const direction = header.getAttribute("aria-sort") === "ascending" ? "descending" : "ascending";
  const numeric = button.dataset.referenceSortNumeric === "true";
  const rows = [...body.rows];

  rows.sort((aRow, bRow) => {
    const a = aRow.cells[columnIndex]?.dataset.referenceSortValue?.trim() ?? "";
    const b = bRow.cells[columnIndex]?.dataset.referenceSortValue?.trim() ?? "";
    if (a === "" || b === "") return a === b ? 0 : a === "" ? 1 : -1;
    const compared = compareValues(a, b, numeric);
    if (compared !== 0) return direction === "descending" ? -compared : compared;
    return Number(aRow.dataset.referenceSortIndex) - Number(bRow.dataset.referenceSortIndex);
  });

  for (const otherHeader of table.querySelectorAll("th[aria-sort]")) {
    otherHeader.removeAttribute("aria-sort");
    const indicator = otherHeader.querySelector("[data-reference-sort-indicator]");
    if (indicator) indicator.textContent = "";
  }

  header.setAttribute("aria-sort", direction);
  const indicator = header.querySelector("[data-reference-sort-indicator]");
  if (indicator) indicator.textContent = direction === "ascending" ? " ▲" : " ▼";
  body.append(...rows);
});
